import { useTranslation } from 'react-i18next';
import { useKeyboardShortcuts } from './useKeyboardShortcuts';

export const useCommandPaletteDialogShortcuts = (handler: () => void): void => {
  const { t } = useTranslation();

  const modifier = /Mac|iPod|iPhone|iPad/.test(navigator.platform)
    ? 'command'
    : 'ctrl';

  useKeyboardShortcuts([
    {
      category: 'common',
      // eslint-disable-next-line prefer-template
      description: t('keyboardShortcuts.openCommandPalette') + ' +/',
      keys: `${modifier}+/`,
      handler,
    },
    {
      category: 'common',
      // eslint-disable-next-line prefer-template
      description: t('keyboardShortcuts.openCommandPalette') + ' +k',
      keys: `${modifier}+k`,
      handler,
    },
  ]);
};
